import React from 'react';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { Skeleton, SkeletonBlock } from '@one-thd/sui-atomic-components';
import { withDynamicComponent, withDynamicImport } from '@thd-nucleus/app-render';
import { withErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { QuestionsAndAnswers } from '@thd-olt-component-react/questions-and-answers';

const placeholder = (
  <div data-component="QuestionsAndAnswersPlaceholder" style={{ width: '100%' }}>
    <Skeleton grow>
      <SkeletonBlock aspect="wide" height={14} width="100%" />
      <SkeletonBlock aspect="wide" height={24} width="100%" />
      <SkeletonBlock aspect="wide" height={14} width="100%" />
      <SkeletonBlock aspect="wide" height={28} width="100%" />
      <SkeletonBlock aspect="wide" height={28} width="100%" />
      <SkeletonBlock aspect="wide" height={28} width="100%" />
      <SkeletonBlock aspect="wide" height={28} width="100%" />
      <SkeletonBlock aspect="wide" height={28} width="100%" />
      <SkeletonBlock aspect="wide" height={28} width="100%" />
      <SkeletonBlock aspect="wide" height={28} width="100%" />
      <SkeletonBlock aspect="wide" height={28} width="100%" />
    </Skeleton>
  </div>
);

const HydratedQandAWrapper = withHydrator({
  id: 'questions-and-answers-wrapper',
  scrollBuffer: 300,
  delay: 1000,
  preserveCtxVal: 'clientStore',
  placeholder
}, QuestionsAndAnswers);

const QandADynamic = withDynamicComponent(HydratedQandAWrapper, { placeholder });
const QandAImporter = withErrorBoundary(QandADynamic);

QandAImporter.dataModel = QuestionsAndAnswers.dataModel;
QandAImporter.propTypes = QuestionsAndAnswers.propTypes;

export default QandAImporter;